import { gql } from '@apollo/client';

export const getProfileQuery = gql`
    query GetProfile {
        user {
            id
            appUserId
            name
            surname
            username
            createdAt
            goalCompletion
            collectedCurrency
            role
            tariff
            subscriptionExpiresAt
            subscription {
                id
                subscriptionCanceledAt
            }
            languageCode
        }
    }
`;
